import {SystemRole} from "@generated"
import {StateLabel} from "@platform/models/state-labels/state-label"

export const SystemRoleLabels: Map<SystemRole | null, StateLabel<SystemRole | null>> = new Map<SystemRole | null, StateLabel<SystemRole | null>>([
    [null, {state: null, label: "None"}],
    [SystemRole.Staff, {state: SystemRole.Staff, label: "Staff"}],
    [SystemRole.Superadmin, {state: SystemRole.Superadmin, label: "Superadmin"}],
])
